module.exports = __webpack_public_path__ + "static/img/banner.f6221057.jpg";